module.exports = __webpack_public_path__ + "img/hr-oil-refinery-shadow.5dc0a6f4.png";